import { IWebSite } from "../../models/WebSite";

export const Emptywebsite: IWebSite = {
    description: "",
    setting_Value: null,
    setting_Id: 0,
    setting_Key: "",
    experience_In: null,
    experience_Total: null,
    number_Of_Allocation: null,
    pV_Calculation_In: null,
    pV_Calculation_Duration: null,
    pV_Experience_In: null,
    pV_Experience_Duration_From: null,
    pV_Experience_Duration_To: null,
    pV_Number_Of_Allocation: null,
    number_Picked_Vendor: null,
    notification_Time: null,
    send_Unserved_Req_Mail: null,
    float_Req_Gap_Time: null,
    no_Sub_Per_Req:null,
    req_Hold_After_Sub:null,
    enable_Testing_Email:null
}

